import React from 'react';
import {BackgroundImageProps} from 'app/utilities/ImageProps';

type GeneralInformationItemProps = {href: string; title: string; image: BackgroundImageProps; isSquareView?: boolean};

const GeneralInformationItem = ({href, image, title, isSquareView}: GeneralInformationItemProps) => {
  if (isSquareView) {
    return (
      <a href={href} className='GeneralInformationItem GeneralInformationItem-square'>
        <div className='GeneralInformationItem-square-content'>
          <div className='GeneralInformationItem-image' {...image} />
          <span className='GeneralInformationItem-title'>{title}</span>
        </div>
        <div className='GeneralInformationItem-square-arrow'>
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
            <path d='M10.7399 12.456C11.1114 12.8332 11.0813 13.417 10.6727 13.7599C10.2954 14.0765 9.72754 14.0772 9.3502 13.7787L9.26005 13.6978L4.26006 8.62093C3.94221 8.29819 3.91572 7.81948 4.1806 7.47074L4.26006 7.37907L9.26005 2.30215C9.63156 1.92493 10.264 1.89713 10.6727 2.24006C11.0499 2.55661 11.1046 3.0784 10.8185 3.4535L10.7399 3.54401L6.351 7.99908L10.7399 12.456Z' fill='#810EA9' />
          </svg>
        </div>
      </a>
    );
  }

  return (
    <a href={href} className='GeneralInformationItem'>
      <div className='GeneralInformationItem-image' {...image} />
      <span className='GeneralInformationItem-title'>{title}</span>
    </a>
  );
};

export default GeneralInformationItem;
